<template>
  <div>
    <RouterView name="header" />
    <div>
      <RouterView name="navigation" />
    </div>
    <div>
      <RouterView name="default" />
    </div>
  </div>
</template>

<style lang="scss">
  body {
    background-repeat: repeat-y;
    background-size: 100%;
  }
</style>

<script>

export default {
  name: 'App'
};
</script>